define('bizzabo/Analytics',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/config',
    'bizzabo/consts',
    'bizzabo/models/Global'
], function(
    $,
    Backbone,
    _,
    CONFIG,
    Consts,
    Global
    ) {

    // Global declaration for Google Analytics
    var _gaq = window._gaq = window._gaq || [];

    var Analytics = function() {

        var CAMPAIGN_MAPPING_PARAM = "z";
        var CAMPAIGN_MAPPING = {
            name : {
                "o" : "organizer_emails",
                "m" : "social_minisite_share"
            },
            medium : {
                "e" : "email",
                "f" : "facebook_share",
                "t" : "twitter_share",
                "l" : "linkedin_share",
                "g" : "google_plus_share",
                "n" : "web_organizer"
            },
            source : {
                "a" : "email_confirmation",
                "b" : "live_event",
                "c" : "unlive_event",
                "d" : "2_days_after_event",
                "e" : "2_days_before_event",
                "f" : "7_days_before_event",
                "g" : "1_month_after_event",
                "h" : "publish_reminder",
                "i" : "rsvp_over_15",
                "w" : "web_minisite",
                "j" : "mobile_join",
                "k" : "mobile_checkin",
                "l" : "mobile_linkedin_invite",
                "q" : "web_organizer_promote_copy",
                "v" : "web_organizer_promote_openURL",
                "x" : "web_organizer_promote"
            }
        };

        var prevURL = "";
        var core = new CoreAnalytics();

        var onMainPageSwitch = function() {
            var url = Backbone.history.getFragment();
            if (prevURL != url) {
                prevURL = url;

                var reportFunction = function() {

                    // remove event id
                    var eventId = activeEvent.get("id");
                    if (_.isUndefined(eventId) || eventId == "") {
                        eventId = "new";
                    }
                    var urlWithNoEventId = "/organizer/" + url.replace(eventId, "");

                    // remove unwanted urls
                    urlWithNoEventId = urlWithNoEventId.replace("promoteEmail", "promote").replace("signin", "").replace("//", "/");

                    core.setEventIdCustomVariable(eventId);
                    core.reportPageView(urlWithNoEventId);
                };

                var waitForEventFunction = function() {
                    Backbone.off(Consts.Notifications.activeEvent.SWITCHED, waitForEventFunction, this);
                    activeEvent = Global.modelPool.getActiveEvent();
                    reportFunction();
                };

                var activeEvent = Global.modelPool.getActiveEvent();
                if (_.isUndefined(activeEvent)) {
                    Backbone.on(Consts.Notifications.activeEvent.SWITCHED, waitForEventFunction, this);
                } else {
                    reportFunction();
                }
            }
        };

        var onEventRequest = function(eventDetails) {
            if (_.isUndefined(eventDetails) ||
                _.isUndefined(eventDetails.category) ||
                _.isUndefined(eventDetails.action)) {
                return;
            }

            core.reportEvent(eventDetails.category, eventDetails.action, eventDetails.label);
        };

        var onSetUserTypeRequest = function(params) {
            core.setUserTypeCustomVariable(params);
        };

        var setupLinksAnalytics = function() {
            var body = $('body');
            body.on('click.analyticsEvents', '.resourceDownload', function(){
                core.reportResourceDownload(this, false);
            });
            body.on('click.analyticsEvents', '.outboundLink', function(){
                core.reportOutboundLink(this);
            });
        };

        var removeLinksAnalytics = function() {
            var body = $('body');
            body.off('.analyticsEvents');
        };

        var setCampaignParams = function(paramsObject) {
            var mappingValue = paramsObject[CAMPAIGN_MAPPING_PARAM];
            if (mappingValue) {
                _.extend(paramsObject, resolveMapping(mappingValue));
            }

            core.setCampaignParams(paramsObject);
        };

        var resolveMapping = function(mappingStringValue) {
            var res = {};
            if (mappingStringValue.length != 3) {
                return res;
            }

            res[core.CAMPAIGN_NAME_PARAM] = CAMPAIGN_MAPPING.name[mappingStringValue.charAt(0)];
            res[core.CAMPAIGN_MEDIUM_PARAM] = CAMPAIGN_MAPPING.medium[mappingStringValue.charAt(1)];
            res[core.CAMPAIGN_SOURCE_PARAM] = CAMPAIGN_MAPPING.source[mappingStringValue.charAt(2)];
            return res;
        };

        var start = function() {
            Backbone.on(Consts.Notifications.analytics.TRACK_EVENT, onEventRequest, this);
            Backbone.on(Consts.Notifications.analytics.SET_USER_TYPE, onSetUserTypeRequest, this);
            Backbone.on(Consts.Notifications.mainPage.SWITCHED, onMainPageSwitch, this);
            setupLinksAnalytics();
        };

        var stop = function() {
            Backbone.off(Consts.Notifications.analytics.TRACK_EVENT, onEventRequest, this);
            Backbone.off(Consts.Notifications.analytics.SET_USER_TYPE, onSetUserTypeRequest, this);
            Backbone.off(Consts.Notifications.mainPage.SWITCHED, onMainPageSwitch, this);
            removeLinksAnalytics();
        };

        /*************** Init ***************/

        start();

        /*************** Public *************/

        return {
            core : core,
            setCampaignParams : setCampaignParams,
            stop : stop
        };
    };

    /* Google Analytics Web Core */
    var CoreAnalytics = function() {

        var CAMPAIGN_SOURCE_PARAM = "utm_source";
        var CAMPAIGN_MEDIUM_PARAM = "utm_medium";
        var CAMPAIGN_NAME_PARAM = "utm_campaign";

        /**
         * Tracks a page view via GA
         * @param opt_pageURL Optional. The url to record. Defaults to the page's url
         */
        var reportPageView = function(opt_pageURL) {
            CONFIG.DEBUG && console.log("GA reports page view: " + (opt_pageURL ? opt_pageURL : "DEFAULT"));
            _gaq.push(['_trackPageview', opt_pageURL]);
        };

        var reportOutboundLink = function(linkEl) {
            reportEvent("Outbound Links", linkEl.href);
            if (linkEl.target != "_blank") {
                setTimeout('document.location = "' + linkEl.href + '"', 100);
            }
        };

        var reportResourceDownload = function(linkEl, forceDelay) {
            reportEvent("Download Resource Links", linkEl.href);
            if (forceDelay) {
                setTimeout('document.location = "' + linkEl.href + '"', 100);
            }
        };

        var reportMiniSiteSocialShare = function(socialNetwork) {
            var url = document.location;
            reportEvent("Social Mini-Site Share", socialNetwork, url);
        };

        /**
         * Reports an event to GA
         * @param category Required. Key.
         * @param action Required. Key. Type of user interaction
         * @param opt_label Optional.
         * @param opt_value Optional. Numerical data
         * @param opt_noninteraction Optional. When true, event hit will not be used in bounce-rate calculation
         */
        var reportEvent = function(category, action, opt_label, opt_value, opt_noninteraction) {
            CONFIG.DEBUG && console.log("GA reports event: " + [category, action, opt_label, opt_value, opt_noninteraction]);
            _gaq.push(['_trackEvent', category, action, opt_label, opt_value, opt_noninteraction]);
        };

        /**
         * Sets a custom GA variable
         * NOTICE: Call BEFORE reporting an event or a page-view
         * @param index Required parameter. Slot (1-5). Limited to 5 for each opt_scope
         * @param name Required parameter. The name acts as a kind of category for the user activity.
         * @param value Required parameter. This value of the custom variable.
         * @param opt_scope Optional parameter. 1: visitor-level, 2: session-level, 3: page-level (default)
         */
        var setCustomVariable = function(index, name, value, opt_scope) {
            CONFIG.DEBUG && console.log("GA set custom variable: " + [index, name, value, opt_scope]);
            _gaq.push(['_setCustomVar', index, name, value, opt_scope]);
        };

        var setUserTypeCustomVariable = function(isLoggedIn) {
            setCustomVariable(1, "logged_in", "" + isLoggedIn, 2);
        };

        var setEventIdCustomVariable = function(eventId) {
            setCustomVariable(2, "event_id", "" + eventId, 2);
        };

        var getCampaignParams = function(linkUrl, source, medium, name) {
            return linkUrl + "?" + CAMPAIGN_SOURCE_PARAM + "=" + source + "&" + CAMPAIGN_MEDIUM_PARAM + "=" + medium + "&" + CAMPAIGN_NAME_PARAM + "=" + name;
        };

        var setCampaignParams = function(paramsObject) {
            var source = paramsObject[CAMPAIGN_SOURCE_PARAM];
            var medium = paramsObject[CAMPAIGN_MEDIUM_PARAM];
            var name = paramsObject[CAMPAIGN_NAME_PARAM];

            var gaqParams = [];
            if (source) {
                gaqParams.push(['_setCampSourceKey', source]);
                _gaq.push(['_setCampSourceKey', source]);
            }
            if (medium) {
                gaqParams.push(['_setCampMediumKey', medium]);
                _gaq.push(['_setCampMediumKey', medium]);
            }
            if (name) {
                gaqParams.push(['_setCampNameKey', name]);
                _gaq.push(['_setCampNameKey', name]);
            }

            if (gaqParams.length > 0) {
                CONFIG.DEBUG && console.log("GA sets campaign parameters: " + gaqParams);
            }
        };

        var getEmailLink = function(linkUrl, source, isUserEmail) {
            var name = isUserEmail ? "user_emails" : "organizer_emails";
            return getCampaignParams(linkUrl, source, "email", name);
        };

        var getMiniSiteLinkForShare = function(linkUrl, medium, source) {
            return getCampaignParams(linkUrl, source, medium, "social_minisite_share");
        };

        var setErrorReportingToGA = function() {
            var thisObject = this;
            if (CONFIG.REPORT_ERRORS_VIA_GA) {
                window.onerror = function(message, file, line) {
                    var sFormattedMessage = '[' + file + ' (' + line + ')] ' + message;
                    thisObject.reportEvent('Exceptions', 'Organizer', sFormattedMessage, null, true);
                };
            }
        };

        var startAnalytics = function() {
            CONFIG.DEBUG && console.log("GA sets account: " + CONFIG.GOOGLE_ANALYTICS_ID);
            _gaq.push(['_setAccount', CONFIG.GOOGLE_ANALYTICS_ID]);
            if (CONFIG.MARKETING_URL.indexOf("www.bizzabo.com") > 0) {
                CONFIG.DEBUG && console.log("GA sets domain: " + CONFIG.MARKETING_URL);
                _gaq.push(['_setDomainName', "bizzabo.com"]);
            }

            (function() {
                var ga = document.createElement('script');
                ga.type = 'text/javascript';
                ga.async = true;
                ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(ga, s);
            })();

            if (CONFIG.ENABLE_HUBSPOT_ANALYTICS) {
                (function(d,s,i,r) {
                    if (d.getElementById(i)){return;}
                    var n=d.createElement(s),e=d.getElementsByTagName(s)[0];
                    n.id=i;n.src='//js.hs-analytics.net/analytics/'+(Math.ceil(new Date()/r)*r)+'/318095.js';
                    e.parentNode.insertBefore(n, e);
                })(document,"script","hs-analytics",300000);
            }

            setErrorReportingToGA();
        };

        /*************** Init ***************/

        startAnalytics();

        /*************** Public *************/

        return{
            reportPageView : reportPageView,
            reportOutboundLink : reportOutboundLink,
            reportResourceDownload : reportResourceDownload,
            reportMiniSiteSocialShare : reportMiniSiteSocialShare,
            reportEvent : reportEvent,
            setUserTypeCustomVariable : setUserTypeCustomVariable,
            setEventIdCustomVariable : setEventIdCustomVariable,
            getCampaignParams : getCampaignParams,
            getEmailLink : getEmailLink,
            getMiniSiteLinkForShare : getMiniSiteLinkForShare,
            setCampaignParams : setCampaignParams,
            CAMPAIGN_SOURCE_PARAM : CAMPAIGN_SOURCE_PARAM,
            CAMPAIGN_MEDIUM_PARAM : CAMPAIGN_MEDIUM_PARAM,
            CAMPAIGN_NAME_PARAM : CAMPAIGN_NAME_PARAM
        };
    };

    return Analytics;

});

